export default function Recruiting() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="recruiting" className="relative py-32 px-6 overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/3d6de42e139de10d26389501af11c8ee.jpg"
          alt="Join Our Team"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-black/50"></div>

      <div className="relative z-10 max-w-4xl mx-auto text-center">
        <h2 className="text-5xl md:text-6xl font-bold text-white mb-6 uppercase tracking-wide">
          Join Our Team
        </h2>
        <p className="text-xl md:text-2xl text-white mb-10 font-light">
          Competitive Pay | Home Time Options | Modern Equipment | Excellent Benefits
        </p>

        <a
          href="https://intelliapp.driverapponline.com/c/monarchxpressllc"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-slate-900 text-white px-10 py-5 rounded-full text-lg font-semibold hover:bg-slate-800 transition-all inline-flex items-center gap-4 whitespace-nowrap cursor-pointer"
        >
          <div className="w-12 h-12 bg-green-600 rounded-full flex items-center justify-center">
            <i className="ri-steering-2-line text-white text-xl"></i>
          </div>
          Apply Now — Driver Opportunities
          <i className="ri-arrow-right-line"></i>
        </a>

        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-6">
          <div className="bg-white/10 backdrop-blur-sm p-6 rounded-2xl">
            <div className="text-3xl font-bold text-white mb-2">$0.60+</div>
            <div className="text-sm text-gray-200">Per Mile</div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm p-6 rounded-2xl">
            <div className="text-3xl font-bold text-white mb-2">Weekly</div>
            <div className="text-sm text-gray-200">Home Time</div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm p-6 rounded-2xl">
            <div className="text-3xl font-bold text-white mb-2">New</div>
            <div className="text-sm text-gray-200">Equipment</div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm p-6 rounded-2xl">
            <div className="text-3xl font-bold text-white mb-2">Full</div>
            <div className="text-sm text-gray-200">Benefits</div>
          </div>
        </div>

        <div className="mt-12 bg-white/10 backdrop-blur-sm p-8 rounded-2xl">
          <h3 className="text-2xl font-bold text-white mb-4">Why Drive for Monarch Xpress?</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-left">
            <div className="flex items-start gap-3">
              <i className="ri-check-line text-green-400 text-xl mt-1"></i>
              <span className="text-white text-sm">Competitive pay with performance bonuses</span>
            </div>
            <div className="flex items-start gap-3">
              <i className="ri-check-line text-green-400 text-xl mt-1"></i>
              <span className="text-white text-sm">Modern, well-maintained fleet</span>
            </div>
            <div className="flex items-start gap-3">
              <i className="ri-check-line text-green-400 text-xl mt-1"></i>
              <span className="text-white text-sm">Flexible home time options</span>
            </div>
            <div className="flex items-start gap-3">
              <i className="ri-check-line text-green-400 text-xl mt-1"></i>
              <span className="text-white text-sm">Health, dental, and vision insurance</span>
            </div>
            <div className="flex items-start gap-3">
              <i className="ri-check-line text-green-400 text-xl mt-1"></i>
              <span className="text-white text-sm">Manual and Automatics</span>
            </div>
            <div className="flex items-start gap-3">
              <i className="ri-check-line text-green-400 text-xl mt-1"></i>
              <span className="text-white text-sm">Guaranteed Miles</span>
            </div>
            <div className="flex items-start gap-3">
              <i className="ri-check-line text-green-400 text-xl mt-1"></i>
              <span className="text-white text-sm">Regional and OTR positions available</span>
            </div>
            <div className="flex items-start gap-3">
              <i className="ri-check-line text-green-400 text-xl mt-1"></i>
              <span className="text-white text-sm">Supportive dispatch team</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}